const coupon = {
    check: (code, plan, lng, _id, _callback) => {
        lng = !lng ? 'en' : lng;
        $.get('/api/discount/' + plan + '/' + code + '?lng=' + lng + "&fp=" + _id).then(function (response) {
            _callback(response);
        }, function (response) {
            _callback();
        });
    }
}

export default coupon;